<template>
  <div class="rights">
    <div style="text-align: center;">
      护照权益
    </div>
    <div
      style="text-align: center;"
      v-if="rightsList.length === 0"
    >
      {{ $route.query.id_no ? '无权益' : '请输入证件号后查看' }}
    </div>
    <div
      class="rights-item"
      v-for="item in rightsList"
      :key="item.card_no"
    >
      <div class="rights-table">
        <template v-for="column in item.items">
          <div :key="column.sort_index">
            {{ column.name }}
          </div>
          <div :key="column.sort_index">
            {{ column.value }}
          </div>
        </template>
      </div>
    </div>
    <div style="text-align: center;margin-top: 20px;">
      防癌权益
    </div>
    <div
      style="text-align: center;"
      v-if="fangaiRightsList.length === 0"
    >
      暂未查到
    </div>
    <div
      class="rights-table fangai-rights-table"
      v-else
    >
      <div>
        权益名称
      </div>
      <div>
        总数
      </div>
      <div>
        已使用
      </div>
      <template v-for="(column, index) in fangaiRightsList">
        <div :key="index">
          {{ column.right_name }}
        </div>
        <div :key="index">
          {{ column.total_count }}
        </div>
        <div :key="index">
          {{ column.used_count }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import workService from "@/apis/work/index.js";
import leXiang from "@/apis/leXiang/index.js";

export default {
  data() {
    return {
      rightsList: [],
      fangaiRightsList: [],
    };
  },
  created() {
    this.rightsByIdNo();
    this.fangaixianLabelStatusSearch();
  },
  methods: {
    fangaixianLabelStatusSearch() {
      const params = {
        work_id: this.$route.query.id,
      };
      leXiang.fangaixianLabelStatusSearch(params).then((res) => {
        this.fangaiRightsList = res;
      });
    },
    rightsByIdNo() {
      const query = this.$route.query;

      if (query.id_no) {
        const params = {
          id_type: query.id_type,
          id_no: query.id_no,
        };
        workService.rightsByIdNo(params).then((res) => {
          this.rightsList = res;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rights {
  padding: 0 20px;
  overflow-y: scroll;
  height: 100%;
}
.rights-item {
  margin: 20px 0;
  background-color: black;
  box-sizing: border-box;
  border: 1px solid black;
  overflow: hidden;
}
.rights-table {
  display: grid;
  grid-template-columns: 50% 50%;
  text-align: center;
  grid-row-gap: 1px;
  grid-column-gap: 1px;

  div {
    background-color: #fff;
    padding: 5px 10px;
  }
}
.fangai-rights-table {
  grid-template-columns: 50% 25% 25%;
  background-color: black;
  border: 1px solid black;
  overflow: hidden;
}
</style>